import sanitizeHtml from 'sanitize-html';

const ALLOWED_STYLES: Record<string, RegExp[]> = {
  color: [/.*/],
  'background-color': [/.*/],
  'font-size': [/.*/],
};

/** Shared allowlist for report / email / agreement HTML (no jsdom). */
export const RICH_HTML_SANITIZE: sanitizeHtml.IOptions = {
  allowedTags: [
    'p',
    'br',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'strike',
    'mark',
    'ul',
    'ol',
    'li',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'span',
    'a',
  ],
  allowedAttributes: {
    a: ['href', 'target', 'rel', 'class'],
    span: ['class', 'style', 'data-color', 'data-type', 'data-start'],
    mark: ['class', 'style', 'data-color'],
    p: ['class', 'style'],
    li: ['class'],
    ul: ['class', 'data-type', 'data-start'],
    ol: ['class', 'data-type', 'data-start'],
  },
  allowedStyles: {
    span: ALLOWED_STYLES,
    mark: ALLOWED_STYLES,
    p: ALLOWED_STYLES,
  },
  allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  transformTags: {
    a: sanitizeHtml.simpleTransform('a', {
      rel: 'noopener noreferrer',
      target: '_blank',
    }),
  },
};

export function looksLikeRichHtml(value: string): boolean {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

export function sanitizeRichHtml(
  html: string,
  options: sanitizeHtml.IOptions = RICH_HTML_SANITIZE,
): string {
  if (!html.trim()) return '';
  return sanitizeHtml(html, options);
}

/** Strip every tag — used when narrative storage is plain text. */
export function stripRichHtml(html: string): string {
  return sanitizeHtml(html, { allowedTags: [], allowedAttributes: {} })
    .replace(/\s+/g, ' ')
    .trim();
}
